import getDelegateListener from 'utils/_get_delegate_listener.js'
import ajaxRequest from 'utils/_ajax-request.js'

/**
 * @param {Event} event
 */
let onCloseAjaxPageElementClick = (event) => {
  let pageAjax = document.getElementById('page-ajax')
  pageAjax.innerHTML = ''
  pageAjax.classList.add('-is-hidden')
}

/**
 * @param {string} selector
 */
export default (selector) => {
  document.addEventListener('click', getDelegateListener(selector, onCloseAjaxPageElementClick))

  window.addEventListener('click', function (e) {
    if( !e.target.closest("#page-ajax") && !e.target.classList.contains("dz-hidden-input") && !e.target.closest(".flatpickr-calendar")
      && !e.target.closest("#baguetteBox-overlay") ) {

      var closeButton = document.querySelector(selector);
      if( closeButton ) {
        onCloseAjaxPageElementClick();
      }
    }
  });
}
